module.exports = __webpack_public_path__ + "static/maquete_4k-a506335d2c5ee1a3c5fe1a89de492829.webp";